import HTTPClient from '../..'

export const userEventCreateAPI = async (eventId: string) => {
  const { data } = await HTTPClient.post('/user_events', { eventId })
  return data
}

export const userEventDeleteAPI = async (id: string) => {
  const { data } = await HTTPClient.delete(`/user_events/${id}`)
  return data
}
